var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-group",
    {
      staticClass: "team-member-dropdown-group",
      attrs: { name: "teamMember", label: "Team Member" },
    },
    [
      _c("md-input", {
        attrs: { type: "hidden" },
        model: {
          value: _vm.selectedMemberId,
          callback: function ($$v) {
            _vm.selectedMemberId = $$v
          },
          expression: "selectedMemberId",
        },
      }),
      _c("vue-select", {
        attrs: {
          reduce: function (item) {
            return item.memberOrCarrierId
          },
          label: "fullName",
          options: _vm.filteredTeamMemberOptions,
          searchable: _vm.$root.isDesktop,
          selectable: function (option) {
            return option.selectable
          },
          "dropdown-overlay": false,
        },
        scopedSlots: _vm._u([
          {
            key: "option",
            fn: function (option) {
              return [
                _vm.displayAvailabilityIndicator
                  ? _c(
                      "div",
                      { staticClass: "member-options" },
                      [
                        option.fullName === "Unassigned"
                          ? _c("div", { staticClass: "status-indicator empty" })
                          : _c("availability-indicator", {
                              attrs: {
                                "is-available":
                                  option.isAvailableBasedOnRosterConfiguration,
                              },
                            }),
                        option.selectable
                          ? _c("span", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(option.fullName) +
                                  "\n                "
                              ),
                            ])
                          : _c("hr"),
                      ],
                      1
                    )
                  : _c("div", [
                      option.selectable
                        ? _c("span", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(option.fullName) +
                                "\n                "
                            ),
                          ])
                        : _c("hr"),
                    ]),
              ]
            },
          },
          {
            key: "selected-option",
            fn: function (option) {
              return [
                _vm.displayAvailabilityIndicator
                  ? _c(
                      "div",
                      { staticClass: "member-options" },
                      [
                        option.fullName === "Unassigned"
                          ? _c("div", { staticClass: "status-indicator empty" })
                          : _c("availability-indicator", {
                              attrs: {
                                "is-available":
                                  option.isAvailableBasedOnRosterConfiguration,
                              },
                            }),
                        option.selectable
                          ? _c("span", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(option.fullName) +
                                  "\n                "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  : _c("div", [
                      option.selectable
                        ? _c("span", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(option.fullName) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                    ]),
              ]
            },
          },
        ]),
        model: {
          value: _vm.selectedMemberId,
          callback: function ($$v) {
            _vm.selectedMemberId = $$v
          },
          expression: "selectedMemberId",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }